import { render, staticRenderFns } from "./PgaAuthorizedOnlyOneContent.vue?vue&type=template&id=145e4438&"
import script from "./PgaAuthorizedOnlyOneContent.vue?vue&type=script&lang=ts&"
export * from "./PgaAuthorizedOnlyOneContent.vue?vue&type=script&lang=ts&"
import style0 from "./PgaAuthorizedOnlyOneContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('145e4438')) {
      api.createRecord('145e4438', component.options)
    } else {
      api.reload('145e4438', component.options)
    }
    module.hot.accept("./PgaAuthorizedOnlyOneContent.vue?vue&type=template&id=145e4438&", function () {
      api.rerender('145e4438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PgaAuthorizedOnlyOneContent.vue"
export default component.exports